/**
 * TBD only a subset have been tested with markdown conversion, ones that HAVE been are
 * numbered list, link, bold, italic, underline, code
 * Others are TBD
 */
export var ElementType;
(function (ElementType) {
    ElementType["BlockQuote"] = "block-quote";
    ElementType["Paragraph"] = "paragraph";
    ElementType["ListItem"] = "list_item";
    ElementType["BulletedList"] = "ul_list";
    ElementType["CheckListItem"] = "check-list-item";
    ElementType["Video"] = "video";
    ElementType["Title"] = "title";
    ElementType["NumberedList"] = "ol_list";
    ElementType["HeadingOne"] = "heading-one";
    ElementType["HeadingTwo"] = "heading-two";
    ElementType["HeadingThree"] = "heading-three";
    ElementType["Image"] = "image";
    ElementType["Link"] = "link";
    ElementType["Mention"] = "mention";
    ElementType["Table"] = "table";
    ElementType["TableCell"] = "table-cell";
    ElementType["EditableVoid"] = "editable-void";
    ElementType["TableRow"] = "table-row";
    ElementType["Left"] = "left";
    ElementType["Center"] = "center";
    ElementType["Right"] = "right";
    ElementType["Button"] = "button";
    ElementType["Justify"] = "justify";
    ElementType["Bold"] = "bold";
    ElementType["Italic"] = "italic";
    ElementType["Underline"] = "underline";
    ElementType["Code"] = "code";
    ElementType["Unknown"] = "unknown";
})(ElementType || (ElementType = {}));
